var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPedidoEnviar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#FAE6E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8616 31.9129C38.1285 31.9129 35.9129 34.1285 35.9129 36.8616V59.8788C35.9129 62.6119 38.1285 64.8275 40.8616 64.8275H54.6719C57.405 64.8275 59.6206 62.6119 59.6206 59.8788V40.3142C59.6206 38.7565 58.8872 37.2898 57.6411 36.3552L53.0377 32.9027C52.1811 32.2602 51.1392 31.9129 50.0685 31.9129H40.8616ZM32 36.8616C32 31.9675 35.9675 28 40.8616 28H50.0685C51.9859 28 53.8515 28.6219 55.3854 29.7723L59.9889 33.2249C62.2203 34.8984 63.5335 37.5249 63.5335 40.3142V59.8788C63.5335 64.7729 59.566 68.7404 54.6719 68.7404H40.8616C35.9675 68.7404 32 64.7729 32 59.8788V36.8616Z",
    fill: "#A51713"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3654 50.6724C39.3654 49.8461 40.0352 49.1763 40.8615 49.1763H49.0454C49.8717 49.1763 50.5415 49.8461 50.5415 50.6724C50.5415 51.4987 49.8717 52.1685 49.0454 52.1685H40.8615C40.0352 52.1685 39.3654 51.4987 39.3654 50.6724Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3654 57.5772C39.3654 56.7509 40.0352 56.0811 40.8615 56.0811H54.6718C55.4981 56.0811 56.1679 56.7509 56.1679 57.5772C56.1679 58.4035 55.4981 59.0733 54.6718 59.0733H40.8615C40.0352 59.0733 39.3654 58.4035 39.3654 57.5772Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPedidoEnviar);
export default __webpack_public_path__ + "static/media/icon_pedido_enviar.5f81314d7ef73330db9bd2892ee39726.svg";
export { ForwardRef as ReactComponent };